import Container from '@/components/Container'
import Section from '@/components/Section'
import React from 'react'
import Title from '@/components/Title'
import Accordion from './components/Accordion'
import style from './styles/game_detail.module.scss'
import PlayButton from '@/components/Button/PlayButton'
import { IGameQuestions } from '@/interfaces/Game'
import HaveQuestionsSmall from '@/components/HaveQuestions/HaveQuestionsSmall'

interface IProps {
  questions?: IGameQuestions[]
  preview: string
  video: string
  title: string
  playVideo: string
  setPlayVideo: any
}

const Learning = ({
  questions,
  preview,
  video,
  title,
  playVideo,
  setPlayVideo
}: IProps): React.ReactElement => {
  const checkVideo = video !== '' && video !== null
  const checkQuestions = questions !== undefined && questions.length > 0

  const handlePlayVideo = (): void => {
    setPlayVideo('learning')
  }

  return (
    <Section>
      <Container>
        {checkVideo
          ? (
            <Title type='h2' theme='h3'>
              Обучение
            </Title>
            )
          : null}
        {checkVideo
          ? (
            <div className={style.learn_video}>
              {playVideo === 'learning'
                ? (
                  <video
                    width='400px'
                    height='300px'
                    controls
                    controlsList='nodownload'
                    autoPlay
                    className={style.learn_video__video}
                  >
                    <source src={video} type='video/mp4' />
                  </video>
                  )
                : (
                  <>
                    <img
                      src={preview}
                      width='1429px'
                      height='795px'
                      alt='Превью видео'
                      className={style.learn_video__preview}
                    />
                    <div className={style.learn_video__gradient}>
                      <span className={style.learn_video__title}>{title}</span>
                    </div>
                    <PlayButton
                      onClick={handlePlayVideo}
                      className={style.learn_video__button}
                    />
                  </>
                  )}
            </div>
            )
          : null}

        {checkQuestions
          ? (
            <Title type='h2' theme='h3'>
              Часто задаваемые вопросы
            </Title>
            )
          : null}

        {checkQuestions
          ? questions.map((el, i) => {
            return (
              <Accordion
                key={el.id}
                title={el.uf_name}
                answer={el.uf_description}
              />
            )
          })
          : ''}
      </Container>
      <HaveQuestionsSmall />
    </Section>
  )
}

export default Learning
